import React, { useEffect } from 'react';
import LoadingAnimation from './LoadingAnimation';

import { Redirect } from 'react-router-dom';
import { useOvermind } from '../../overmind';

import {GoogleAPI,
        GetliveGTMpayload} from '../../utils/util-networkCalls.js';

import {SetWindowVars,
        TagDataTableArray,
        VariableDataTableArray,
        TriggerDataTableArray} from '../../utils/util-reformatingContainer';

import {StringifyNestedObjects} from '../../utils/util-JSONtools';


import {useStyles}from '../furniture/Dashboard-Config'
import AppBarAndDrawer from '../furniture/AppBarAndDrawer'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import * as Sentry from "@sentry/react";



export default function NewSessionLoader() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  const pullLiveContainerData = (accessToken, containerIndex) =>{
    let containerObject = state.containerList[containerIndex];

    GoogleAPI(containerObject.path+'/versions:live',accessToken)
    .then(response =>{


      if(typeof response.error !== 'undefined'){
          // API returns an error so go back to login screen
          actions.updateFlag({'name':'cookieFound','payload':false});
          Sentry.captureMessage("Cookie Token has Expired");
      }else{

          let tagDataTable = TagDataTableArray(response);
          let variableDataTable =VariableDataTableArray(response);
          let triggerDataTable = TriggerDataTableArray(response);
          let gtmPayload = GetliveGTMpayload(containerObject.publicId);

          //Data for Documentation and Explore
          actions.addFormattedData({'name':'liveContainerConfig', 'payload':response});
          actions.addFormattedData({'name':'tagDataTable', 'payload':TagDataTableArray(response)});
          actions.addFormattedData({'name':'variableDataTable', 'payload':VariableDataTableArray(response)});
          actions.addFormattedData({'name':'triggerDataTable', 'payload':TriggerDataTableArray(response)});

          // Data for Documentaton Donut recharts
          actions.addTagDonutChartData();
          actions.addTriggerDonutChartData();
          actions.addVariableDonutChartData();

          //Data for recommendations
          actions.getRecommendations();
          //actions.addFormattedData({'name':'gtmPayLoad', 'payload':GetliveGTMpayload(containerObject.publicId)});

          if (state.debug === true){
            console.log('Page Refresh Loading state Logged')
            Sentry.setContext("Overmind Loader State Object", StringifyNestedObjects(state, ['authState'], ['liveContainerConfig','docDonutChart','recommendation','tagDataTable','triggerDataTable','variableDataTable'], false));
          }

          //Sentry.captureMessage("Context Check");
          let windowData = {
                            "container":response,
                            "tagData": tagDataTable,
                            "variableData": variableDataTable,
                            "triggerData": triggerDataTable,
                            "gtmPayLoad": gtmPayload
                           };

          SetWindowVars(windowData,false);

          actions.updateFlag({'name':'cookieFound','payload':true});
          actions.updateFlag({'name':'loadingData','payload':false});
          actions.updateFlag({'name':'blockAccess','payload':false});
          actions.updateFlag({'name':'activeStep','payload':0});
      }

    });
  };

  useEffect(() => {
    //actions.loadingDataFlag(true);
    if( typeof state.containerList !== 'undefined'){
       // User preferences have been set by Data has not been retrieved
    }else{
      // User preferences not retrieved yet needs to pull from localStorage
      let cookieValue = localStorage.getItem('sid');


      if(typeof cookieValue === 'undefined'){
        // Cookie not Found, send user to Homepage
        actions.updateFlag({'name':'cookieFound','payload':false});
      }else{
        let credentials = JSON.parse(atob(cookieValue));

        //actions.updateFlag({'name':'authState.googleAccessToken','payload':credentials.sid});
        actions.updateFlag({'name':'accountIndex','payload':credentials.aid});
        actions.updateFlag({'name':'containerIndex','payload':credentials.cid});
        actions.updateFlag({'name':'authState','payload':credentials.uid});

        // Setting Account List
        actions.getAccountList(credentials.alist);
        actions.updateFlag({'name':'isAccountSet','payload':true});

        //  Setting Container List
        actions.getContainerList(credentials.clist);
        actions.updateFlag({'name':'isContainerSet','payload':true});

        actions.updateFlag({'name':'disableNextStepState','payload':[false,false,false]});

        // Pulling live container data
        pullLiveContainerData(credentials.sid, credentials.cid);

    }
  }
});

  if(state.cookieFound === false){
    return(<Redirect to='/'/>);
  }
  if(state.loadingData){
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <LoadingAnimation/>
              </Grid>
            </Grid>
          </Container>
        </main>
      </div>


    );
  }else{
    return(<Redirect to={state.redirectPath}/>);
  }
}
